import { z } from 'zod';

export const ConfigsStepStatus = z.enum(['REQUIRED', 'OPTIONAL', 'DISABLED']);

export type ConfigsStepStatusT = z.infer<typeof ConfigsStepStatus>;
